export const currencies = {
  AED: {
    name: "UAE Dirham",
    symbol: "د.إ",
    country: "United Arab Emirates",
  },
  SAR: {
    name: "Saudi Riyal",
    symbol: "﷼",
    country: "Saudi Arabia",
  },
  KWD: {
    name: "Kuwaiti Dinar",
    symbol: "د.ك",
    country: "Kuwait",
  },
  BHD: {
    name: "Bahraini Dinar",
    symbol: ".د.ب",
    country: "Bahrain",
  },
  OMR: {
    name: "Omani Rial",
    symbol: "ر.ع.",
    country: "Oman",
  },
  QAR: {
    name: "Qatari Riyal",
    symbol: "ر.ق",
    country: "Qatar",
  },
  INR: {
    name: "Indian Rupee",
    symbol: "₹",
    country: "India",
  },
  MYR: {
    name: "Malaysian Ringgit",
    symbol: "RM",
    country: "Malaysia",
  },
};
